module.exports = __webpack_public_path__ + "img/21.72064ff0.gif";